// Shared menu filtering/splitting logic used by both the left sidebar and the
// horizontal top-nav, so the two layouts always show identical menu items.
//
// Rules (extracted from the original sidebar.jsx):
//  - Company id 1 hides menu id 22.
//  - Loan Officers (and one specific legacy user_id) cannot see /transactions
//    or /boarding_houses.
//  - position < 7  => MAIN MENU items.
//  - position >= 7 => REPORTS items (the caller decides who may see these).

const LOAN_OFFICER_RESTRICTED_LINKS = ["/transactions", "/boarding_houses"];
const LEGACY_RESTRICTED_USER_ID = "f9b234a8-4e89-42b3-bbb2-881919074349";

export const getMenuSections = (menus = [], user, company) => {
  // Filter out menu ID 22 when company ID is 1
  const filteredMenus =
    company?.id === 1 ? menus.filter((item) => item.id !== 22) : menus;

  // Filter out restricted menu items for loan officers
  const roleFilteredMenus = filteredMenus.filter((item) => {
    if (
      user?.role === "Loan Officer" ||
      user?.user_id === LEGACY_RESTRICTED_USER_ID
    ) {
      return !LOAN_OFFICER_RESTRICTED_LINKS.some((link) =>
        item.link?.includes(link),
      );
    }
    return true;
  });

  const mainMenuItems = roleFilteredMenus.filter((item) => item.position < 7);
  const reportMenuItems = roleFilteredMenus.filter((item) => item.position >= 7);

  return { mainMenuItems, reportMenuItems };
};
